var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndQuizPass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 113,
    viewBox: "0 0 90 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 62.5V90L17 105.5L36 86L53 105.5V90V62.5",
    stroke: "#6846C7",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9161 15.2746C57.6131 6.05253 47.0134 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70C54.33 70 70 54.33 70 35C70 34.6696 69.9954 34.3403 69.9863 34.0122L64.878 37.7236C63.5019 53.0158 50.6505 65 35 65C18.4315 65 5 51.5685 5 35C5 18.4315 18.4315 5 35 5C44.0168 5 52.1045 8.97793 57.6038 15.2746H63.9161Z",
    fill: "#6846C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5L76.0413 17.4377H89.119L78.5389 25.1246L82.5801 37.5623L72 29.8754L61.4199 37.5623L65.4611 25.1246L54.881 17.4377H67.9587L72 5Z",
    fill: "#6846C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndQuizPass);
export default __webpack_public_path__ + "static/media/endQuizPass.91fe14cd189c6c9b9c778ea95882b0fe.svg";
export { ForwardRef as ReactComponent };